import { APP_MODE } from '../../sharedTypes'

export interface authState {
  access: string
  refresh: string
  fulfilled: boolean
  rejected: boolean
  fetching: boolean
  errorMessage: string
  userRoles?: string[]
  userType: string
  userProfileId: number
  organizationId?: number
  organizationType?: APP_MODE | null
  organizationTitle?: string
  userDetails: {
    role?: string
    userID?: number
    user?: {
      first_name?: string
      last_name?: string
    }
  }
  userEditAccessOnReport: boolean
}

export interface ILoggedUser {
  refresh: string
  access: string
}

export interface IRefreshTokenResponse {
  access: string
}

export enum userTypes {
  ORG_ADMIN = 'ORG_ADMIN',
  SYS_ADMIN = 'SYS_ADMIN',
  TEAM_MEMBER = 'TEAM_MEMBER',
}

export enum userRoles {
  DESIGNATED_RECEIVER = 'DESIGNATED_RECEIVER',
  INVESTIGATOR = 'INVESTIGATOR',
  ADMIN = 'ADMIN',
}

export const roleMappings: { [key in userRoles]: number } = {
  [userRoles.INVESTIGATOR]: 1,
  [userRoles.ADMIN]: 2,
  [userRoles.DESIGNATED_RECEIVER]: 3,
};

export enum usersReportAccess {
  CAN_EDIT = 'CAN_EDIT',
  CAN_VIEW = 'CAN_VIEW',
}
